import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import {PageProps as CraftablePageProps, User} from "craftable-pro/types/page";
import {PageProps} from "@/craftable-pro/Types/page";

export function useUser() {
    const user = computed(() => (usePage().props as CraftablePageProps)?.auth.user);
    const isClient = computed(() => (usePage().props as PageProps)?.auth.is_client);

    return {
        user: user,
        isClient: isClient,
    };
}
